// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
}

.venue-item {
  background: #353535;
  padding: 12px;
  display: flex;
  margin-top: auto;
  transition: 0.3s linear, opacity 1s ease-in-out;
  text-align: left;
  border-radius: 21px;
  cursor: pointer;
  min-height: 130px;
}
@media (min-width: 991px) {
  .venue-item {
    padding: 15px 5px;
    border: none;
    border-bottom: 0.5px solid #222222;
    margin-bottom: 12px;
  }
}
.venue-item p {
  margin: 0;
}
.venue-item .name {
  text-align: left;
}
.venue-item .address {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-align: right;
  text-transform: uppercase;
  color: var(--color-black-alt);
}
.venue-item:hover .name {
  color: var(--accent-color);
}

.right-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.info-block {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.info-block .icon {
  height: 22px;
  width: 22px;
}
.info-block .icon:first-child {
  margin-right: 3.5px;
}
.info-block .icon ion-icon {
  width: 100%;
  height: 100%;
}

.open-block {
  display: flex;
  justify-content: flex-end;
}
.open-block .label-open {
  width: 80%;
  min-height: 25px;
  border-radius: var(--border-radius-default);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--ion-color-primary);
}
@media (max-width: 992px) {
  .open-block .label-open {
    width: 100%;
  }
}
.open-block .label-open ion-label {
  font-family: AppFontMedium, sans-serif;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  color: var(--color-white);
}

.distance {
  height: 21px;
  min-width: 45px;
  padding: 2px 8px !important;
  text-align: center;
  margin-right: 5px;
}

.second-row {
  margin-top: 2px;
}

.app-logo {
  width: 60px;
  height: 35px;
  color: var(--ion-color-gold);
}
.app-logo.selected {
  color: white;
}

.wrap {
  padding-top: 10px;
}

a {
  height: 21px;
}

.box {
  color: var(--ion-color-main);
  border: 2px solid var(--ion-color-main);
  padding: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.box.selected {
  color: white;
  border: 2px solid white;
}

.venue-status {
  color: white;
  background: var(--ion-color-gold);
  border-radius: 2px;
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px 8px !important;
  min-width: 45px;
  text-align: center;
  margin-right: 5px;
}
.venue-status.selected {
  background: white;
  color: var(--ion-color-primary);
}

.preorder-type {
  --background: #f6f0eb;
  color: #9f9f9f;
  font-weight: bold;
  cursor: pointer;
  --padding: 16px;
  border-radius: 0;
  border: none !important;
  padding: 0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  margin: 0;
  --detail-icon-color: var(--ion-color-main);
  --detail-icon-opacity: 1;
}
.preorder-type.active {
  transition: 0.3s linear;
  --background: #f6f0eb;
  color: var(--ion-color-main);
}
.preorder-type h3 {
  font-family: AppFont-black, sans-serif;
  font-size: 14px;
}
.preorder-type p {
  color: var(--ion-color-primary);
  font-weight: 400;
}

.border-top {
  border-top: 0.5px solid #e8e8e8;
}

.align-center {
  text-align: center;
}

.button-separator {
  width: 3px;
  height: 100%;
}

.top-row {
  padding: 0px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.arrow-down {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  height: 6px;
  width: 10px;
  transition: opacity 0.3s ease-out;
}

.venue-item:has(.type_show) .arrow-down {
  opacity: 0;
}
.venue-item:has(.type_show) .separator--top {
  opacity: 0;
  margin: 0;
}

.small-margin-top {
  margin-top: 6px;
}

.top-end-img {
  position: absolute;
  top: 0;
  right: 0;
  height: 36px;
  width: 40px;
}

.type-col {
  padding: 11px;
}

.delivery-col {
  padding: 5px 11px 11px;
}

.item {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
}
.item .item-left-part {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.item .type-icon {
  height: 100%;
  margin-right: 8px;
  opacity: 0.3;
  transition: opacity 2s;
}
.item .item-type {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.06em;
  text-align: left;
  color: var(--ion-color-primary);
  opacity: 0.3;
  transition: opacity 2s;
  text-transform: uppercase;
}
.item .item-desc {
  font-family: AppFont;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
  opacity: 0.3;
  transition: opacity 2s;
}
.item .item-arrow {
  height: 100%;
  opacity: 0.3;
  transition: opacity 2s;
}
.item.active .type-icon {
  opacity: 1;
}
.item.active .item-arrow {
  opacity: 1;
}
.item.active .item-type {
  opacity: 1;
}
.item.active .item-type .item-desc {
  opacity: 1;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: opacity 0.3s ease-out, margin 0.5s ease-out;
}
.separator--top {
  margin-top: 15px;
  margin-bottom: 5px;
}
.separator .line {
  height: 8px;
  background-size: 7px 100%;
}

.delivery-col {
  position: relative;
}
.delivery-col .title-block {
  margin-bottom: 16px;
}
.delivery-col .title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.06em;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.delivery-col .subtitle {
  font-family: AppFontLight;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: left;
}
.delivery-col .delivery-item {
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  opacity: 0.5;
}
.delivery-col .delivery-item.active {
  opacity: 1;
}
.delivery-col .arrow-up {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%) rotate(180deg);
  height: 6px;
  width: 10px;
}

.type-wrapper {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 0px;
  transition: max-height 1s;
  overflow: auto;
}
.type-wrapper.type_show {
  max-height: 800px;
}

.distance-block {
  padding-top: 5px;
  font-size: 10px;
  color: #000;
  font-family: AppFontLight, sans-serif;
  text-align: right;
}

.time-open {
  padding-top: 5px;
  font-size: 10px;
  font-family: AppFontBold;
  color: black;
  text-align: right;
}

.not-selected {
  opacity: 0.5;
}

.marker-icon {
  width: 32px;
}
.marker-icon img {
  width: 14px;
  height: 14px;
}

ion-button {
  min-height: 26px;
  margin-top: 10px;
  color: var(--accent-color);
}

.btn {
  color: var(--accent-color);
  background: transparent;
  padding: 7px 10px;
  border-radius: 7px;
  border: 1px solid var(--accent-color);
  margin-top: 7px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-suggestion/venue-suggestion.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,aAAA;EACA,sBAAA;AAAD;;AAGA;EACC,mBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EAGA,+CAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAFD;ACdE;EDKF;IAaE,iBAAA;IACA,YAAA;IACA,kCAAA;IACA,mBAAA;EAAA;AACF;AAIC;EACC,SAAA;AAFF;AAKC;EACC,gBAAA;AAHF;AAMC;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EAEA,6BAAA;AALF;AAQE;EACC,0BAAA;AANH;;AAaA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;AAVD;;AAaA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAVD;AAYC;EACC,YAAA;EACA,WAAA;AAVF;AAYE;EACC,mBAAA;AAVH;AAYE;EACC,WAAA;EACA,YAAA;AAVH;;AAcA;EACC,aAAA;EACA,yBAAA;AAXD;AAaC;EACC,UAAA;EAIA,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAdF;ACxEE;ED4ED;IAGE,WAAA;EAHD;AACF;AAWE;EACC,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,yBAAA;AAVH;;AAsBA;EACC,YAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AAnBD;;AAsBA;EACC,eAAA;AAnBD;;AAsBA;EACC,WAAA;EACA,YAAA;EACA,4BAAA;AAnBD;AAqBC;EACC,YAAA;AAnBF;;AAuBA;EACC,iBAAA;AApBD;;AAwBA;EACC,YAAA;AArBD;;AAwBA;EACC,4BAAA;EACA,uCAAA;EACA,YAAA;EACA,0CAAA;AArBD;AAuBC;EACC,YAAA;EACA,uBAAA;AArBF;;AAyBA;EACC,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAtBD;AAwBC;EACC,iBAAA;EACA,+BAAA;AAtBF;;AA0BA;EACC,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;EACA,SAAA;EACA,0CAAA;EACA,wBAAA;AAvBD;AAyBC;EACC,uBAAA;EACA,qBAAA;EACA,4BAAA;AAvBF;AA0BC;EACC,sCAAA;EACA,eAAA;AAxBF;AA2BC;EACC,+BAAA;EACA,gBAAA;AAzBF;;AA6BA;EACC,+BAAA;AA1BD;;AA6BA;EACC,kBAAA;AA1BD;;AA6BA;EACC,UAAA;EACA,YAAA;AA1BD;;AA6BA;EACC,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA1BD;;AA6BA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;AA1BD;;AA8BC;EACC,UAAA;AA3BF;AA8BC;EACC,UAAA;EACA,SAAA;AA5BF;;AAgCA;EACC,eAAA;AA7BD;;AAgCA;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AA7BD;;AAgCA;EACC,aAAA;AA7BD;;AAgCA;EACC,sBAAA;AA7BD;;AAgCA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EAEA,eAAA;AA9BD;AA+BC;EACC,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AA7BF;AAgCC;EACC,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AA9BF;AAoCC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;AAlCF;AAqCC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAnCF;AAsCC;EACC,YAAA;EACA,YAAA;EACA,sBAAA;AApCF;AAwCE;EACC,UAAA;AAtCH;AAwCE;EACC,UAAA;AAtCH;AAwCE;EACC,UAAA;AAtCH;AAwCG;EACC,UAAA;AAtCJ;;AA4CA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uDAAA;AAzCD;AA2CC;EACC,gBAAA;EACA,kBAAA;AAzCF;AA4CC;EACC,WAAA;EAEA,yBAAA;AA3CF;;AA+CA;EACC,kBAAA;AA5CD;AA6CC;EACC,mBAAA;AA3CF;AA6CC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AA3CF;AA6CC;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA3CF;AA8CC;EACC,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA5CF;AA6CE;EACC,UAAA;AA3CH;AA+CC;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,0CAAA;EACA,WAAA;EACA,WAAA;AA7CF;;AAgDA;EACC,wBAAA;EAAA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AA7CD;AA8CC;EACC,iBAAA;AA5CF;;AAgDA;EACC,gBAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;EACA,iBAAA;AA7CD;;AA+CA;EACC,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;AA5CD;;AA8CA;EACC,YAAA;AA3CD;;AA8CA;EACC,WAAA;AA3CD;AA4CC;EACC,WAAA;EACA,YAAA;AA1CF;;AA8CA;EACC,gBAAA;EACA,gBAAA;EACA,0BAAA;AA3CD;;AA6CA;EACC,0BAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;AA1CD","sourcesContent":["@import \"../../../theme/mixins.scss\";\n:host {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.venue-item {\n\tbackground: #353535;\n\tpadding: 12px;\n\tdisplay: flex;\n\tmargin-top: auto;\n\n\n\ttransition: 0.3s linear, opacity 1s ease-in-out;\n\ttext-align: left;\n\tborder-radius: 21px;\n\tcursor: pointer;\n\tmin-height: 130px;\n\t@include desktop {\n\t\tpadding: 15px 5px;\n\t\tborder: none;\n\t\tborder-bottom: 0.5px solid #222222;\n\t\tmargin-bottom: 12px;\n\t}\n\t&.selected {\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t}\n\n\t.name {\n\t\ttext-align: left;\n\t}\n\n\t.address {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 14px;\n\t\tletter-spacing: 0.08em;\n\t\ttext-align: right;\n\t\ttext-transform: uppercase;\n\n\t\tcolor: var(--color-black-alt);\n\t}\n\t&:hover {\n\t\t.name {\n\t\t\tcolor: var(--accent-color);\n\t\t}\n\t\t// border-radius: 6px;\n\t\t// background: #f2dbd9 !important;\n\t}\n}\n\n.right-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.info-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t.icon {\n\t\theight: 22px;\n\t\twidth: 22px;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 3.5px;\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n.open-block {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\t// padding-top: 5px;\n\t.label-open {\n\t\twidth: 80%;\n\t\t@include mobile {\n\t\t\twidth: 100%;\n\t\t}\n\t\tmin-height: 25px;\n\t\tborder-radius: var(--border-radius-default);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground-color: var(--ion-color-primary);\n\n\t\tion-label {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tfont-size: 10px;\n\t\t\tline-height: 14px;\n\t\t\tletter-spacing: 0.08em;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t\t// &.enabled {\n\t\t\t\n\n\t\t// \tion-label {\n\t\t\t\t\n\t\t// \t}\n\t\t// }\n\t}\n}\n\n.distance {\n\theight: 21px;\n\tmin-width: 45px;\n\tpadding: 2px 8px !important;\n\ttext-align: center;\n\tmargin-right: 5px;\n}\n\n.second-row {\n\tmargin-top: 2px;\n}\n\n.app-logo {\n\twidth: 60px;\n\theight: 35px;\n\tcolor: var(--ion-color-gold);\n\n\t&.selected {\n\t\tcolor: white;\n\t}\n}\n\n.wrap {\n\tpadding-top: 10px;\n\n}\n\na {\n\theight: 21px;\n}\n\n.box {\n\tcolor: var(--ion-color-main);\n\tborder: 2px solid var(--ion-color-main);\n\tpadding: 2px;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\n\t&.selected {\n\t\tcolor: white;\n\t\tborder: 2px solid white;\n\t}\n}\n\n.venue-status {\n\tcolor: white;\n\tbackground: var(--ion-color-gold);\n\tborder-radius: 2px;\n\tfont-size: 13px;\n\twidth: fit-content;\n\tpadding: 2px 8px !important;\n\tmin-width: 45px;\n\ttext-align: center;\n\tmargin-right: 5px;\n\n\t&.selected {\n\t\tbackground: white;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.preorder-type {\n\t--background: #f6f0eb;\n\tcolor: #9f9f9f;\n\tfont-weight: bold;\n\tcursor: pointer;\n\t--padding: 16px;\n\tborder-radius: 0;\n\tborder: none !important;\n\tpadding: 0;\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tmargin: 0;\n\t--detail-icon-color: var(--ion-color-main);\n\t--detail-icon-opacity: 1;\n\n\t&.active {\n\t\ttransition: 0.3s linear;\n\t\t--background: #f6f0eb;\n\t\tcolor: var(--ion-color-main);\n\t}\n\n\th3 {\n\t\tfont-family: AppFont-black, sans-serif;\n\t\tfont-size: 14px;\n\t}\n\n\tp {\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 400;\n\t}\n}\n\n.border-top {\n\tborder-top: 0.5px solid #e8e8e8;\n}\n\n.align-center {\n\ttext-align: center;\n}\n\n.button-separator {\n\twidth: 3px;\n\theight: 100%;\n}\n\n.top-row {\n\tpadding: 0px;\n\tposition: relative;\n\tmargin-bottom: 10px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.arrow-down {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\theight: 6px;\n\twidth: 10px;\n\ttransition: opacity 0.3s ease-out;\n}\n\n.venue-item:has(.type_show) {\n\t.arrow-down {\n\t\topacity: 0;\n\t}\n\n\t.separator--top {\n\t\topacity: 0;\n\t\tmargin: 0;\n\t}\n}\n\n.small-margin-top {\n\tmargin-top: 6px;\n}\n\n.top-end-img {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\theight: 36px;\n\twidth: 40px;\n}\n\n.type-col {\n\tpadding: 11px;\n}\n\n.delivery-col {\n\tpadding: 5px 11px 11px;\n}\n\n.item {\n\twidth: 100%;\n\theight: 30px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 16px;\n\n\tcursor: pointer;\n\t.item-left-part {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t}\n\n\t.type-icon {\n\t\theight: 100%;\n\t\tmargin-right: 8px;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t.item-info {\n\t}\n\n\t.item-type {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary);\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.item-desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t.item-arrow {\n\t\theight: 100%;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t&.active {\n\t\t.type-icon {\n\t\t\topacity: 1;\n\t\t}\n\t\t.item-arrow {\n\t\t\topacity: 1;\n\t\t}\n\t\t.item-type {\n\t\t\topacity: 1;\n\n\t\t\t.item-desc {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\ttransition: opacity 0.3s ease-out, margin .5s ease-out;\n\n\t&--top {\n\t\tmargin-top: 15px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.line {\n\t\theight: 8px;\n\t\t// background-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n}\n\n.delivery-col {\n\tposition: relative;\n\t.title-block {\n\t\tmargin-bottom: 16px;\n\t}\n\t.title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\t.subtitle {\n\t\tfont-family: AppFontLight;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t}\n\n\t.delivery-item {\n\t\theight: 28px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\t\topacity: 0.5;\n\t\t&.active {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t.arrow-up {\n\t\tposition: absolute;\n\t\tbottom: 10px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%) rotate(180deg);\n\t\theight: 6px;\n\t\twidth: 10px;\n\t}\n}\n.type-wrapper {\n\theight: fit-content;\n\tmax-height: 0px;\n\ttransition: max-height 1s;\n\toverflow: auto;\n\t&.type_show {\n\t\tmax-height: 800px;\n\t}\n}\n\n.distance-block {\n\tpadding-top: 5px;\n\tfont-size: 10px;\n\tcolor: #000;\n\tfont-family: AppFontLight, sans-serif;\n\ttext-align: right;\n}\n.time-open {\n\tpadding-top: 5px;\n\tfont-size: 10px;\n\tfont-family:AppFontBold ;\n\tcolor: black;\n\ttext-align: right;\n}\n.not-selected  {\n\topacity: 0.5;\n}\n\n.marker-icon {\n\twidth: 32px;\n\timg {\n\t\twidth: 14px;\n\t\theight: 14px\n\t}\n}\n\nion-button {\n\tmin-height: 26px;\n\tmargin-top: 10px;\n\tcolor: var(--accent-color);\n}\n.btn {\n\tcolor: var(--accent-color);\n\tbackground: transparent;\n\tpadding: 7px 10px;\n\tborder-radius: 7px;\n\tborder: 1px solid var(--accent-color);\n\tmargin-top: 7px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
